import { searchObj } from './util'
import { entity, isEntity } from './entity';

const searchProps = searchObj(window.location.search);
let language = ''
if (searchProps.lang) {
    language = searchProps.lang === 'zh_cn' ? 'zh' : 'en'
} else {
    language = isEntity('gtarcade') ? 'en' : 'zh'
}
const http_origin = isEntity('gtarcade') ? 'gtarcade' : (entity.name || 'youzu')
export async function getFetch(url = '', params = {}, needLanguage) {
    let paramsArray = [];
    const addObj = needLanguage ? {
        language,
        'http-origin': http_origin
    } : {}
    Object.keys(params).forEach(key => paramsArray.push(key + '=' + params[key]))
    if (paramsArray.length > 0) {
        if (url.search(/\?/) === -1) {
            url += '?' + paramsArray.join('&')
        } else {
            url += '&' + paramsArray.join('&')
        }
    }
    // Default options are marked with *
    const response = await fetch(url, {
        method: 'GET', // *GET, POST, PUT, DELETE, etc.
        mode: 'cors', // no-cors, *cors, same-origin
        cache: 'no-cache', // *default, no-cache, reload, force-cache, only-if-cached
        credentials: 'same-origin', // include, *same-origin, omit
        headers: {
            'Content-Type': 'application/json; charset=UTF-8',
            'token': window.location.search.substring(1),
            ...addObj
        },
        redirect: 'follow', // manual, *follow, error
        referrerPolicy: 'strict-origin-when-cross-origin', // no-referrer, *no-referrer-when-downgrade, origin, origin-when-cross-origin, same-origin, strict-origin, strict-origin-when-cross-origin, unsafe-url
    });
    return response.json(); // parses JSON response into native JavaScript objects
}

export async function postFetch(url = '', data = {}) {
    data.origin = 1;
    // Default options are marked with *
    const response = await fetch(url, {
        method: 'POST', // *GET, POST, PUT, DELETE, etc.
        mode: 'cors', // no-cors, *cors, same-origin
        cache: 'no-cache', // *default, no-cache, reload, force-cache, only-if-cached
        credentials: 'same-origin', // include, *same-origin, omit
        headers: {
            'Content-Type': 'application/json; charset=UTF-8',
            'token': window.location.search.substring(1),
        },
        dataType: "jsonp",
        redirect: 'follow', // manual, *follow, error
        referrerPolicy: 'strict-origin-when-cross-origin', // no-referrer, *no-referrer-when-downgrade, origin, origin-when-cross-origin, same-origin, strict-origin, strict-origin-when-cross-origin, unsafe-url
        body: JSON.stringify(data) // body data type must match "Content-Type" header
    });
    return response.text().then(function (text) {
        return text ? JSON.parse(text) : {}
    }); // parses JSON response into native JavaScript objects
}

export async function getGssfServerList(game_id, op_id) {
    // Default options are marked with *
    const response = await fetch(`https://gssf.youzu.com/server/queryServerList?appId=service.youzu.com&gameId=${game_id}&opId=${op_id}&columns=["server_id","server_name"]`, {
        method: 'GET', // *GET, POST, PUT, DELETE, etc.
        mode: 'no-cors', // no-cors, *cors, same-origin
        cache: 'no-cache', // *default, no-cache, reload, force-cache, only-if-cached
        credentials: 'same-origin', // include, *same-origin, omit
        redirect: 'follow', // manual, *follow, error
        referrerPolicy: 'strict-origin-when-cross-origin', // no-referrer, *no-referrer-when-downgrade, origin, origin-when-cross-origin, same-origin, strict-origin, strict-origin-when-cross-origin, unsafe-url
    });
    return response.text().then(function (text) {
        return text ? JSON.parse(text) : {}
    }); // parses JSON response into native JavaScript objects
}

export async function formDataPostFetch(url = '', data = {}) {
    let formData = new FormData();
    Object.keys(data).map(item => {
        formData.append(item, data[item]);
        return true;
    });
    const response = await fetch(url, {
        method: 'POST',
        body: formData
    });
    return response.text().then(function (text) {
        return text ? JSON.parse(text) : {}
    }); // parses JSON response into native JavaScript objects
}